module.exports = __webpack_public_path__ + "img/sld_annunciator_t1_b1.4bbe2dbe.svg";